import type { ReactElement } from "react"
import React, { Fragment } from "react"
import PlainLinkAtm from "@onestore/hel/dist/components/atoms/PlainLinkAtm"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type { NestedGenericPagesType } from "@gatsby-plugin-generic-page/sections/SitemapSection/components/GenericPageSitemap"

type NestedListType = {
  pages: NestedGenericPagesType
  leftSpace: number
}

const NestedGenericPagesList = ({
  pages,
  leftSpace,
}: NestedListType): ReactElement<NestedListType> => {
  const convertUrlToString = (url: string): string => {
    const replacesChars = url.replace(/-/g, " ")

    return replacesChars.charAt(0).toUpperCase() + replacesChars.slice(1)
  }

  return (
    <>
      {Object.entries(pages).map(([key, value]) => {
        const hasChildren = Object.keys(value.children).length > 0

        return (
          <Fragment key={key}>
            <PushOrg leftSpace={leftSpace} hasNoReset>
              <PlainLinkAtm
                title={value.flatData.metaTitle}
                typography={hasChildren ? "small4" : "small2"}
                type="underline"
                emphasis="half"
                to={value.flatData.url}
              >
                • {convertUrlToString(key)}
              </PlainLinkAtm>
            </PushOrg>

            {hasChildren ? (
              <>
                {NestedGenericPagesList({
                  pages: value.children,
                  leftSpace: leftSpace + 2,
                })}
              </>
            ) : null}
          </Fragment>
        )
      })}
    </>
  )
}

export default NestedGenericPagesList
